import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchVenuesFromFirestore, fetchBusinessHoursFromFirestore } from './venuesService';

/**
 * Redux Thunks for venue operations.
 *
 * @function fetchVenues
 * @description Async thunk that fetches venues from Firestore
 * @returns {Promise<Array>} Array of venue objects
 * @throws {RejectWithValue} Error message if fetch fails
 */

export const fetchVenues = createAsyncThunk('venues/fetchVenues', async () => {
  return await fetchVenuesFromFirestore();
});

export const fetchBusinessHours = createAsyncThunk('venues/fetchBusinessHours', async (venueId) => {
  return await fetchBusinessHoursFromFirestore(venueId);
});
